import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getDataAvailable = (state: ContentPluginRootState) => state.data.requestVersion !== -1;

export default getDataAvailable;
